'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { TextButton } from '@/shared/ui'

import { Layout } from '../layout'

type Props = {
  wide?: boolean
}

export const SimpleNavigationBarUI = ({ wide = false }: Props) => {
  const pathname = usePathname()

  const showHostIntroButton = pathname === '/sign-in'

  return (
    <Layout wide={wide}>
      <div className="flex shrink-0 items-center justify-end gap-4">
        {showHostIntroButton && (
          <TextButton asChild color="gray" size="small" weight="normal">
            <Link href="/host/main">삼삼엠투 호스트 시작하기</Link>
          </TextButton>
        )}
      </div>
    </Layout>
  )
}
